import * as io from 'io-ts';
import { Money } from './Money';

const PaymentProductType = io.union([
  io.literal('INSTALLMENTS'),
  io.literal('SPLITPAY'),
  io.literal('HYBRID_LINE_OF_CREDIT'),
]);

export type PaymentProductType = io.TypeOf<typeof PaymentProductType>;

const PaymentProduct = io.type({
  id: io.string,
  programID: io.string,
  name: io.string,
  description: io.string,
  numPayments: io.number,
  paymentFrequency: io.string,
  minInterestRateBPS: io.number,
  maxInterestRateBPS: io.number,
  paymentMethodTypes: io.array(io.string),
  autopayRequired: io.boolean,
  type: PaymentProductType,
  requiredDownPaymentBPS: io.number,
  legalAgreements: io.record(io.string, io.unknown),
  policies: io.record(io.string, io.unknown),
  workflowIDs: io.record(io.string, io.unknown),
  createdAt: io.string,

  // Probably not relevant for us?
  deletedAt: io.union([io.string, io.null]),
});

const MerchantValues = io.type({
  minCartSize: Money,
  maxCartSize: Money,
  preauthAmount: io.union([io.number, io.null]),
});

export type MerchantValues = io.TypeOf<typeof MerchantValues>;

type PaymentProduct = io.TypeOf<typeof PaymentProduct>;

export const MerchantPaymentProduct = io.type({
  paymentProduct: PaymentProduct,
  merchantValues: MerchantValues,
});

export type MerchantPaymentProduct = io.TypeOf<typeof MerchantPaymentProduct>;

export const MerchantPaymentProductResponse = io.type({
  merchantPaymentProducts: io.array(MerchantPaymentProduct),
});

export type MerchantPaymentProductResponse = io.TypeOf<
  typeof MerchantPaymentProductResponse
>;

export const PaymentProductConfiguration = io.type({
  paymentProduct: PaymentProduct,
  enrollments: io.array(MerchantValues),
});

export type PaymentProductConfiguration = io.TypeOf<
  typeof PaymentProductConfiguration
>;

export const PaymentProductConfigurationResponse = io.type({
  items: io.array(PaymentProductConfiguration),
});

export type PaymentProductConfigurationResponse = io.TypeOf<
  typeof PaymentProductConfigurationResponse
>;
